module.exports = __webpack_public_path__ + "static/media/icon-add-item.caa7d272.svg";